<div class="page-wrap d-flex flex-row align-items-center">
    <div class="container" style="padding-top: 200px;">
        <div class="row justify-content-center">
            <div class="col-md-12 text-center">
                <h1 style="color: #E65400" class="display-1 d-block">{{'NotFoundPortal.404' | translate}}</h1>
                <div class="mb-4 lead">{{'NotFoundPortal.title' | translate}}</div>
            </div>
        </div>
    </div>
</div>